import { AbstractControl } from '@angular/forms';

// @dynamic
export class FormUtil {
    static hasValidatorKey = (abstractControl: AbstractControl, key: string = 'required'): boolean => {
        if (!abstractControl) {
            return false;
        }

        if (abstractControl.validator) {
            const validator = abstractControl.validator({} as AbstractControl);
            if (validator && key in validator) {
                return true;
            }
        }

        return false;
    };

    static getFirstError = (control: AbstractControl) =>
        control.errors
            ? Object.keys(control.errors)
                  .map((key) => control.errors[key])[0]
                  .getMessage()
            : 'Fehler nicht festgelegt!';
}
